<template>
  <div id="app" :style="themeStyle">
    <component :is="this.$route.meta.layout || 'div'">
      <router-view />
    </component>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'App',

    data() {
      return {};
    },
    computed: {
      ...mapGetters([
        'GetVersion', 'GetTenant'
      ]),
      themeStyle: function () {
        return {
          '--header-bg-color': this.GetTenant() && this.GetTenant().color || '#0c7bc3'
        };
      }
    }
  }
</script>

<style>
  html, body {
    font-family: 'Poppins', sans-serif !important;
  }

  /* Phones and tablets: never let stray horizontal overflow widen the page. Chrome for Android grows the
     layout viewport to fit anything wider than the screen, which stretches the fixed header
     past the screen edge and leaves a blank strip beside the content. Wide grids and tables
     scroll inside their own containers, so page-level sideways scrolling is not needed. */
  @media (max-width: 991.98px) {
    html, body {
      overflow-x: hidden;
    }

    /* Forty-odd list screens (Hot Deals, Room, Building, Emailer, accounting reports, ...) share
       one template: a card with an inline min-width: fit-content and a table inside a
       small-only responsive wrapper. On a phone the card grows to the table width, the page
       cannot scroll sideways (rule above), and only the left part of the screen is reachable.
       Below lg the card stays inside the screen and the wrapper scrolls at any width. */
    .card[style*="fit-content"] {
      min-width: 0 !important;
    }

    .table-responsive-sm {
      display: block;
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
  }

  /* Report filter rows: the "Tick to include" checkboxes keep their 28px indent on desktop
     only; below lg each checkbox takes its own half or full row and the indent would push
     it past the screen edge. */
  @media (min-width: 992px) {
    .report-tick-offset {
      margin-left: 28px;
    }
  }

  .panel-light-custom {
    background-color: #ececec !important;
    border-radius: 2px !important;
  }

  .tab-text-color {
    color: #6c757d !important;
  }

  .btn-light-custom {
    color: black !important;
    background-color: #e6e6e6 !important;
    border-color: #d2d6da !important;
    box-shadow: none !important;
  }

  .btn-icon-size {
    width: 2.4rem !important;
    height: 2rem !important;
    justify-content: center !important;
    display: flex !important;
    align-items: center !important;
    font-size: 1.2rem !important;
  }

  .modal-header {
    background-color: #0c7bc3 !important;
    color: white !important;
  }

  .custom-pre {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    padding: 9.5px !important;
    margin: 0 0 10px !important;
    font-size: 13px !important;
    line-height: 1.428571429 !important;
    color: #333 !important;
    word-break: break-all !important;
    word-wrap: break-word !important;
    background-color: #f5f5f5 !important;
    border: 1px solid #dee2e6 !important;
    border-radius: 4px !important;
  }

  pre {
    font-family: 'Poppins', sans-serif !important;
    padding: unset !important;
  }

  .layout-navbar-fixed .wrapper .sidebar-dark-primary .brand-link:not([class*="navbar"]) {
    background-color: #1f2d3d;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue